import { PROJECT_TYPES } from "src/constants";

const AUDITOR_FIELDS_BY_PROJECT_TYPE = Object.freeze({
  [PROJECT_TYPES.AGROFORESTRY]: ["auditor"],
  [PROJECT_TYPES.CARBON_CREDIT]: ["auditorValidation", "auditorVerification"],
});

function requireInvestment(project) {
  if (!project.investment || typeof project.investment !== "object") {
    throw new Error(`Investment data is required for project type ${project.type}.`);
  }
  return project.investment;
}

function requireAuditorAddress(value, label) {
  if (typeof value !== "string" || !value.trim()) {
    throw new Error(`${label} is required.`);
  }
  return value.trim().toLowerCase();
}

export function isAssignedProjectAuditor(project, accountAddress) {
  const auditorFields = AUDITOR_FIELDS_BY_PROJECT_TYPE[project.type];
  if (!auditorFields) {
    throw new Error(`Unsupported investment project type: ${project.type}`);
  }
  const investment = requireInvestment(project);
  const account = requireAuditorAddress(accountAddress, "Current auditor address");
  const assignedAuditors = auditorFields.map((field) =>
    requireAuditorAddress(
      investment[field],
      `${project.type} investment ${field}`
    )
  );
  return assignedAuditors.includes(account);
}
